import { addColumnHeader, addDueDateToDate } from "../helpers";
import { parseCustomDate } from "../utils";

export const insertCustomData = (
  worksheet,
  outputSheet,
  rules,
  rule,
  fileSettings,
  inputColumns,
  outputColumns,
) => {
  Object.entries(rule.customColumnMappings).forEach(([key, value]) => {
    addColumnHeader(outputSheet, outputColumns, value);
  });

  const useOutputOf = rules.find(
    (rle) => parseInt(rle._id) === parseInt(rule.useOutputOf),
  );

  if (useOutputOf) {
    if (useOutputOf.ranges) {
      const inputColumn = inputColumns.find(
        (clmObj) => clmObj.inColChr === useOutputOf.inputColumn[0],
      );
      InsertDueDateForRanges(
        worksheet,
        outputSheet,
        useOutputOf.inputColumn,
        rule.outputColumns,
        useOutputOf.output,
        inputColumn,
      );
    } else {
      insertDataUsingIndexes(
        worksheet,
        outputSheet,
        rule.customColumnMappings,
        rule.selectOptionFromInput,
        inputColumns,
        useOutputOf,
        rule.skipEmptyCells,
        rule.skipZeroValues,
        rule,
      );
    }
  } else {
    insertDataUsingColumns(
      outputSheet,
      rule.customColumnMappings,
      rule.selectOptionFromInput,
      inputColumns,
    );
  }
};
const insertDataUsingColumns = (
  outputSheet,
  columnMappings,
  selectedOption,
  inputColumns,
) => {
  let outputRow = 2;
  Object.entries(columnMappings).forEach(([key, value]) => {
    const inputColumnData = inputColumns.find(
      (clmObj) => clmObj.inColChr === key,
    );
    outputSheet.getCell(`${value}${outputRow}`).value =
      inputColumnData[selectedOption];
    outputRow++;
  });
};

const insertDataUsingIndexes = (
  worksheet,
  outputSheet,
  columnMappings,
  selectedOption,
  inputColumns,
  useOutputOf,
  skipEmptyCells,
  skipZeroValues,
  rule,
) => {
  let outputRow = { current: 2 };

  if (useOutputOf.appliedRule === 1) {
    // group by
    Object.entries(useOutputOf.output).forEach(([key, record], index) => {
      fetchGroupByDataToInsert(
        worksheet,
        outputSheet,
        columnMappings,
        inputColumns,
        selectedOption,
        outputRow,
        key,
        skipEmptyCells,
        useOutputOf,
        index,
        record,
      );
    });
  } else {
    useOutputOf.output.forEach((rowIndex, index) => {
      fetchDataToInsert(
        worksheet,
        outputSheet,
        columnMappings,
        inputColumns,
        selectedOption,
        outputRow,
        rowIndex,
        skipEmptyCells,
        skipZeroValues,
        useOutputOf,
        index,
      );
    });
  }
};

const fetchDataToInsert = (
  worksheet,
  outputSheet,
  columnMappings,
  inputColumns,
  selectedOption,
  outputRow,
  rowIndex,
  skipEmptyCells,
  skipZeroValues,
  useOutputOf,
  index,
) => {
  Object.entries(columnMappings).forEach(([key, value]) => {
    const inputColumnData = inputColumns.find(
      (clmObj) => clmObj.inColChr === key,
    );
    if (!inputColumnData) return;
    let flag = null;

    let val = inputColumnData[selectedOption];

    switch (selectedOption) {
      case "inColDesc":
        flag = worksheet.getCell(`${key}${rowIndex}`).value;
        if (skipEmptyCells && (flag === "" || flag == null)) {
          return;
        }
        if (skipZeroValues && Number(flag) === 0) return;

        break;
      case "inColContactName":
        flag = worksheet.getCell(`${key}${rowIndex}`).value;
        if (skipEmptyCells && (flag === "" || flag == null)) {
          return;
        }
        if (skipZeroValues && Number(flag) === 0) return;
        break;

      case "inColExchangeRate":
        val = val;
        break;
      case "exchangeRateMultiply":
        const multiplier =
          parseFloat(worksheet.getCell(`${key}${rowIndex}`).value) || 1;
        val = inputColumnData["inColExchangeRate"];
        val *= multiplier;
        break;
      case "inColCharCode":
        flag = worksheet.getCell(`${key}${rowIndex}`).value;
        let refData = inputColumns.find(
          (clmObj) => clmObj.inColChr === useOutputOf.inputColumn,
        );
        let newDate = worksheet.getCell(
          `${useOutputOf.inputColumn}${rowIndex}`,
        ).value;

        if (skipEmptyCells && (flag === "" || flag == null)) {
          return;
        }
        if (skipZeroValues && Number(flag) === 0) return;

        val = `${parseCustomDate(
          newDate,
          refData.toDateFormat || refData.inputDateFormat,
        )}${val}`;
        break;

      case "insertDate":
        val = worksheet.getCell(`${useOutputOf.inputColumn}${rowIndex}`).value;
        flag = worksheet.getCell(`${key}${rowIndex}`).value;
        if (skipEmptyCells && (flag === "" || flag == null)) {
          return;
        }

        if (skipZeroValues && Number(flag) === 0) return;
        break;

      case "inColDueDate":
        flag = worksheet.getCell(`${key}${rowIndex}`).value;
        if (skipEmptyCells && (flag === "" || flag == null)) {
          return;
        }

        if (skipZeroValues && Number(flag) === 0) return;

        let refData2 = inputColumns.find(
          (clmObj) => clmObj.inColChr === useOutputOf.inputColumn,
        );

        let currentDate = worksheet.getCell(
          `${useOutputOf.inputColumn}${rowIndex}`,
        ).value;
        val = addDueDateToDate(
          currentDate,
          refData2.toDateFormat || refData2.inputDateFormat,
          val,
        );
        break;

      case "insertCellData":
        val = worksheet.getCell(`${key}${rowIndex}`).value;
        if (skipZeroValues && Number(val) === 0) {
          return;
        }
        if (skipEmptyCells && (flag === "" || flag == null)) {
          return;
        }
        break;
      case "inColAccountNo":
        val = inputColumnData.inColAccountNo;
        break;
      case "inColDcCode":
        val = inputColumnData.inColDcCode;
        break;
      case "oid":
        val = index + 1;
        break;
      default:
        return;
    }

    outputSheet.getCell(`${value}${outputRow.current}`).value = val;
    outputRow.current++;
  });
};

const fetchGroupByDataToInsert = (
  worksheet,
  outputSheet,
  columnMappings,
  inputColumns,
  selectedOption,
  outputRow,
  key,
  skipEmptyCells,
  useOutputOf,
  index,
  record,
) => {
  // desciption holds both datepart and colDescription, using split to separate them and find the correct input column using description.
  // then using inColChr to get the output column from columnMappings
  const [datepart, colDescription] = key.split("*");

  const referenceInputColumn = inputColumns.find(
    (clmObj) => clmObj.inColDesc.trim() === colDescription.trim(),
  );

  if (!referenceInputColumn) return;

  const outputCol = columnMappings[referenceInputColumn.inColChr];

  const dateColumn = inputColumns.find(
    (col) => col.inColChr === useOutputOf?.dateColumn,
  );

  // === Helper for writing to output ===
  const writeValue = (value) => {
    outputSheet.getCell(`${outputCol}${outputRow.current}`).value = value;
    outputRow.current++;
  };

  switch (selectedOption) {
    case "inColDueDate":
      let convertToDateFormat1 =
        referenceInputColumn.toDateFormat ||
        referenceInputColumn.inputDateFormat;
      if (!convertToDateFormat1) {
        const findDateFormat = inputColumns.find(
          (clmObj) => clmObj.inColDT === "3",
        );
        convertToDateFormat1 =
          findDateFormat.toDateFormat || findDateFormat.inputDateFormat;
      }
      let dueDate = addDueDateToDate(
        datepart,
        convertToDateFormat1,
        referenceInputColumn.inColDueDate,
      );
      writeValue(dueDate);

      break;
    case "inColCharCode":
      let charCode = referenceInputColumn.inColCharCode || ""; // Retrieve character code from inputColumns

      let convertToDateFormat =
        referenceInputColumn.toDateFormat ||
        referenceInputColumn.inputDateFormat;
      if (!convertToDateFormat) {
        const findDateFormat = inputColumns.find(
          (clmObj) => clmObj.inColDT === "3",
        );
        convertToDateFormat =
          findDateFormat.toDateFormat || findDateFormat.inputDateFormat;
      }

      // Convert date format from MM/DD/YYYY to DDMMYY
      let formattedDate = parseCustomDate(datepart, convertToDateFormat);
      let formattedValue = `${formattedDate}${charCode}`; // Concatenate formatted date with charCode
      writeValue(formattedValue);

      break;
    case "insertStartDate":
      if (!dateColumn) return;
      const startDate = record[dateColumn.inColChr]?.startDate;
      writeValue(startDate);
      break;
    case "insertEndDate":
      if (!dateColumn) return;
      const endDate = record[dateColumn.inColChr]?.endDate;

      writeValue(endDate);
      break;
    case "insertStartDatePlusDueDate":
      if (!dateColumn) return;
      const startDate1 = record[dateColumn.inColChr]?.startDate;

      writeValue(
        addDueDateToDate(
          startDate1,
          dateColumn?.toDateFormat || dateColumn?.inputDateFormat,
          dateColumn?.inColDueDate || 0,
        ),
      );
      break;
    case "insertEndDatePlusDueDate":
      if (!dateColumn) return;
      const endDate1 = record[dateColumn.inColChr]?.endDate;

      writeValue(
        addDueDateToDate(
          endDate1,
          dateColumn?.toDateFormat || dateColumn?.inputDateFormat,
          dateColumn?.inColDueDate || 0,
        ),
      );
      break;
    case "inColDesc":
      writeValue(referenceInputColumn.inColDesc);
      break;
    case "inColContactName":
      writeValue(referenceInputColumn.inColContactName);
      break;
    default:
      return;
  }
};

const InsertDueDateForRanges = (
  worksheet,
  outputSheet,
  inputColumn,
  outputColumn,
  ranges,
  inputColumnObj,
) => {
  let outputRow = 2;
  for (let i = 0; i < ranges.length; i++) {
    const [startRow, endRow] = ranges[i];

    const inputCellValue = worksheet.getCell(`${inputColumn}${startRow}`).value;
    const dueDate = addDueDateToDate(
      inputCellValue,
      inputColumnObj.toDateFormat || inputColumnObj.inputDateFormat,
      inputColumnObj.inColDueDate,
    );

    for (let rowIndex = startRow + 1; rowIndex <= endRow; rowIndex++) {
      outputSheet.getCell(`${outputColumn}${outputRow}`).value = dueDate;
      outputRow++;
    }
  }
};
